import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import CardMedia from '@mui/material/CardMedia';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const valStyle = {
  fontSize: '28px',
  fontWeight: '750',
};

const MaterialItemCard = ({ data, handleClick }) => {
  return (
    <Box sx={{ margin: 0.5 }}>
      <Card
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          cursor: "pointer",
          borderRadius: 2,
          minHeight: 125,
        }}
        raised
        onClick={() => handleClick(data.url)}
      >
        <CardActionArea>
          <CardContent sx={{ flex: 1 }}>
            <Box sx={{ display: "flex", flexDirection: "row", gap: 2, alignItems: "center" }}>
              <CardMedia
                component="img"
                sx={{ width: 80, height: "auto" }}
                image={data.imgPath}
                alt="Image"
              />
              <Typography component="div" variant="h5" color="primary" style={valStyle}>
                {data.name}
              </Typography>
            </Box>
          </CardContent>
        </CardActionArea>
      </Card>
    </Box>
  );
};

export default MaterialItemCard;